var ActionHandler =
/** @class */
function () {
  function ActionHandler() {}

  ActionHandler.prototype.registerRoot = function (root) {
    this._root = root;
  };

  Object.defineProperty(ActionHandler.prototype, "root", {
    get: function get() {
      return this._root;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ActionHandler.prototype, "state", {
    get: function get() {
      return this.root ? this.root.state : this.getInitialState();
    },
    enumerable: true,
    configurable: true
  });

  ActionHandler.prototype.getInitialState = function () {
    return {};
  };

  ActionHandler.prototype.setState = function (state, callback) {
    var root = this._root;

    if (!root) {
      throw new ReferenceError('Root element is not assigned yet');
    }

    root.setState(state, callback);
  };

  return ActionHandler;
}();

export { ActionHandler };